import { ENVIRONMENTS } from './constants.js';

/**
 * @returns {string} The environment name
 */
export function getEnvironment() {
	if (typeof window === 'undefined') {
		console.log('__NODE_ENV__', __NODE_ENV__); // eslint-disable-line no-undef
		switch (
			__NODE_ENV__ // eslint-disable-line no-undef
		) {
			case 'review':
				return ENVIRONMENTS.REVIEW;
			case 'development':
				return ENVIRONMENTS.DEVELOPMENT;
			default:
				return ENVIRONMENTS.PRODUCTION;
		}
	}

	const hostname = window.location.hostname;

	// Review-app hosts (e.g. review-classic-123.sbx-abcmouse.dev.app.abcmouse.com)
	// are distinct from web.dev so they get their own Sentry sampling policy.
	// startsWith, not includes: a future 'preview-'/'product-review-' host must
	// not classify as review.
	if (hostname.startsWith('review-') || hostname.includes('.sbx-')) {
		return ENVIRONMENTS.REVIEW;
	}

	if (hostname.includes('web.dev')) {
		return ENVIRONMENTS.DEVELOPMENT;
	}

	if (hostname.includes('localhost') || hostname.includes('local.dev')) {
		return ENVIRONMENTS.LOCAL_DEVELOPMENT;
	}

	if (hostname.includes('stage')) {
		return ENVIRONMENTS.STAGING;
	}

	return ENVIRONMENTS.PRODUCTION;
}

/**
 * Returns an environment-specific value based on the current environment.
 * Generic helper that works with any value type (strings, objects, functions, etc.).
 * If the value is not set for a specific environment, a fallback value is used.
 * @template T
 * @param {object} values - Environment-specific values
 * @param {T} [values.local] - Value for LOCAL_DEVELOPMENT environment
 * @param {T} [values.dev] - Value for DEVELOPMENT environment
 * @param {T} [values.staging] - Value for STAGING environment
 * @param {T} values.production - Value for PRODUCTION environment (required, used as fallback)
 * @returns {T} The value corresponding to the current environment
 */
export function returnValueByEnv({ local, dev, staging, production }) {
	const env = getEnvironment();
	switch (env) {
		case ENVIRONMENTS.LOCAL_DEVELOPMENT:
			return local ?? dev ?? production;
		// Review apps run against dev backends, so they resolve like DEVELOPMENT.
		case ENVIRONMENTS.REVIEW:
		case ENVIRONMENTS.DEVELOPMENT:
			return dev ?? production;
		case ENVIRONMENTS.STAGING:
			return staging ?? production;
		default:
			return production;
	}
}
